export const errorMessage: any = {
    
}

export const printLogs = (logs: any) => {
    console.log(logs)
}